import React from 'react';
import { BsDownload } from 'react-icons/bs';

const Repayments = () => {
  return (
    <div>
      <table>
        <thead>
          <tr>
            <th>Customer Name</th>
            <th>Loan ID</th>
            <th>Repayment Amount</th>
            <th>Loan Repayment Date</th>
            <th>Loan Principal Repayment</th>
            <th>Last Interest Repayment</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Lindsey&nbsp;Stroud</td>
            <td>LN0001</td>
            <td>$600,000</td>
            <td>14-10-2021</td>
            <td>$100,000</td>
            <td>$100,000</td>
          </tr>
          <tr>
            <td>Lindsey&nbsp;Stroud</td>
            <td>LN0001</td>
            <td>$600,000</td>
            <td>14-10-2021</td>
            <td>$100,000</td>
            <td>$100,000</td>
          </tr>
          <tr>
            <td>Lindsey&nbsp;Stroud</td>
            <td>LN0001</td>
            <td>$600,000</td>
            <td>14-10-2021</td>
            <td>$100,000</td>
            <td>$100,000</td>
          </tr>
          <tr>
            <td>Lindsey&nbsp;Stroud</td>
            <td>LN0001</td>
            <td>$600,000</td>
            <td>14-10-2021</td>
            <td>$100,000</td>
            <td>$100,000</td>
          </tr>
          <tr>
            <td>Lindsey&nbsp;Stroud</td>
            <td>LN0001</td>
            <td>$600,000</td>
            <td>14-10-2021</td>
            <td>$100,000</td>
            <td>$100,000</td>
          </tr>
          <tr>
            <td>Lindsey&nbsp;Stroud</td>
            <td>LN0001</td>
            <td>$600,000</td>
            <td>14-10-2021</td>
            <td>$100,000</td>
            <td>$100,000</td>
          </tr>
          <tr>
            <td>Lindsey&nbsp;Stroud</td>
            <td>LN0001</td>
            <td>$600,000</td>
            <td>14-10-2021</td>
            <td>$100,000</td>
            <td>$100,000</td>
          </tr>
          <tr>
            <td>Lindsey&nbsp;Stroud</td>
            <td>LN0001</td>
            <td>$600,000</td>
            <td>14-10-2021</td>
            <td>$100,000</td>
            <td>$100,000</td>
          </tr>
          <tr>
            <td>Lindsey&nbsp;Stroud</td>
            <td>LN0001</td>
            <td>$600,000</td>
            <td>14-10-2021</td>
            <td>$100,000</td>
            <td>$100,000</td>
          </tr>
        </tbody>
      </table>
      <div className="download-btn">
        <button><span>Download</span><BsDownload /></button>
      </div>
    </div>
  )
}

export default Repayments;